import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SchemaConfig } from './schema.config';
import $ from 'jquery';
import { Utils } from './Utils';

@Injectable({
  providedIn: 'root'
})
export class SchemaService {

  constructor(private http: HttpClient) {

  }

  public getSchema(configUrl: string, configListName: string, spxId: string, productName: string) {
    const apiUrl = Utils.removeSlash(configUrl) +
    '/_api/web/lists/getbytitle(\'' + configListName + '\')/Items?$select=Settings&$filter=SPXId eq \'' + spxId +
    '\' and Product eq \'' + productName + '\'&$top eq 1';

    const headers = new HttpHeaders({ 'Accept': 'application/json;odata=verbose' });
    const options = { headers: headers };

    return this.getSchemaObservable(apiUrl, options);

  }

  private getSchemaObservable(apiUrl, options) {
    return new Observable<any>((obsr) => {
        this.http.get(apiUrl, options)
        .subscribe((schema: any) => {
          if (!schema) {
            obsr.error('Problem Getting Schema');
          } else {
            if (schema.d.results.length === 0 ||
              !schema.d.results[0].Settings) {
              obsr.next(null);
            } else {
              const result = JSON.parse(schema.d.results[0].Settings);
              if (result) {
                obsr.next(result);
              } else {
                obsr.next(null);
              }
            }
          }
          obsr.complete();
        }, (error: any): any => {
          obsr.error(error);
          obsr.complete();
        });
      });
  }

  private createConfig(spxId, settings, productName): SchemaConfig {
    const cfg = <SchemaConfig> {};
    cfg.Settings = settings;
    cfg.SPXId = spxId;
    cfg.Product = productName;
    cfg.Title = `${productName}_${spxId}`;
    return cfg;
  }

  public saveConfig(configUrl: string, configListName: string, spxId: string, productName: string, settings: string) {
    return new Observable<number>((obsr) => {
      this.getFormDigest(configUrl)
      .subscribe((formDigest) => {
        let cfg = JSON.stringify(this.createConfig(spxId, settings, productName));
        cfg = cfg.slice(0, -1) + ',\'__metadata\': { \'type\': \'SP.Data.SPXConfigListItem\' }}';
        const url = Utils.removeSlash(configUrl) + '/_api/web/lists/getbytitle(\'' + configListName + '\')/Items';
        this.getConfig(configUrl, productName, spxId, configListName)
        .subscribe((config) => {
          try {
            if (config === null) {
              const headers = new HttpHeaders({ 'Content-Type': 'application/json;odata=verbose',
                              'X-RequestDigest': formDigest,
                              'Accept': 'application/json;odata=verbose'  });
              const options = { headers: headers };
              this.http.post(url, cfg, options)
              .subscribe((response: any) => {
                if (!response) {
                    obsr.next(null);
                } else {
                    obsr.next(response.d.Id);
                }
                obsr.complete();
              }, (error) => {
                obsr.error(error);
                obsr.complete();
              });
            } else {
                const itemUrl = url + '(' + config.Id + ')';
                const headers = new HttpHeaders({ 'Content-Type': 'application/json;odata=verbose',
                                'X-RequestDigest': formDigest,
                                'IF-MATCH': '*',
                                'X-HTTP-Method': 'MERGE',
                                'Accept': 'application/json;odata=verbose'  });
                const options = { headers: headers };
                this.http.post(itemUrl, cfg, options)
                .subscribe((response) => {
                    if (!response) {
                        obsr.next(null);
                    } else {
                        obsr.next(config.Id);
                    }
                    obsr.complete();
                }, (error) => {
                    obsr.error(error);
                    obsr.complete();
                });
            }
          } catch (error) {
              obsr.error(error);
              obsr.complete();
          }
        }, (error) => {
            console.log(JSON.stringify(error));
            obsr.error(error);
            obsr.complete();
        });
      }, (error) => {
          obsr.error(error);
          obsr.complete();
      });
    });
  }

  public getConfig(configUrl: string, productName: string, wpId: string, configListName: string) {
      return new Observable<SchemaConfig>((obsr) => {
          const url = Utils.removeSlash(configUrl) + '/_api/web/lists/getbytitle(\'' + configListName + '\')/Items?$filter=SPXId eq \''
                      + wpId + '\' and Product eq \'' + productName + '\'&$top eq 1&$select=Settings,Id,Product,Title,SPXId';
          const headers = new HttpHeaders({ 'Accept': 'application/json;odata=verbose' });
          const options = { headers: headers };

          this.http.get(url, options)
          .subscribe((response: any) => {
              try {
                  if (response && response.d.results
                      && response.d.results.length > 0 ) {
                      const result: SchemaConfig = <SchemaConfig> response.d.results[0];
                      if (result) {
                          obsr.next(result);
                      } else {
                          obsr.error('Problem parsing Schema');
                      }
                  } else {
                      obsr.next(null);
                  }
                  obsr.complete();
              } catch (error) {
                  obsr.error(error);
                  obsr.complete();
              }
          }, (error: any): any => {
              obsr.error(error);
              obsr.complete();
          });
      });
  }

  public getFormDigest(configUrl: string): Observable<string> {

    return new Observable<string>((observable) => {
        const formDigest = $('#__REQUESTDIGEST').val();
        if (formDigest) {
            observable.next(formDigest as string);
            observable.complete();
        } else {
            this.http.post(Utils.removeSlash(configUrl) + '/_api/contextinfo', '')
            .subscribe((data) => {
                try {
                    observable.next((<any>data).FormDigestValue);
                } catch (error) {
                    observable.error(error);
                } finally {
                    observable.complete();
                }
            }, (error: any) => {
                observable.error(error);
                observable.complete();
            });
        }
    });
  }
}
